import { Box, Icon, keyframes, Stack, Text } from '@chakra-ui/react'
import { FC } from 'react'
import { BsCameraVideo } from 'react-icons/bs'

// Slow "online" blink for the doctor-available dot.
const onlineBlink = keyframes`
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.35; }
`
// Expanding halo ring radiating from the dot.
const onlinePulse = keyframes`
  0%   { transform: scale(0.9); opacity: 0.5; }
  70%, 100% { transform: scale(2.6); opacity: 0; }
`

/** "Doctors online" — slow blinking green dot with a radiating halo. */
export const OnlineDot: FC = () => (
  <Box position="relative" w={2.5} h={2.5} flexShrink={0}>
    <Box
      position="absolute"
      inset={0}
      borderRadius="full"
      bg="green.400"
      animation={`${onlinePulse} 2s ease-out infinite`}
    />
    <Box
      position="relative"
      w="full"
      h="full"
      borderRadius="full"
      bg="green.400"
      animation={`${onlineBlink} 1.8s ease-in-out infinite`}
    />
  </Box>
)

/**
 * Floating "Médico disponível agora" card laid over a landing hero image.
 * Fixed Cuidei copy, shared by the pharmacy (/farma) and pathology landings.
 */
const CuideiAvailabilityPill: FC = () => (
  <Box
    position="absolute"
    left={{ base: 4, md: 6 }}
    right={{ base: 4, md: 6 }}
    bottom={{ base: 4, md: 6 }}
    bg="white"
    borderRadius="2xl"
    boxShadow="lg"
    px={5}
    py={3}
  >
    <Stack direction="row" align="center" justify="space-between">
      <Stack direction="row" align="center" spacing={3}>
        <Box w={9} h={9} borderRadius="full" bg="green.50" display="flex" alignItems="center" justifyContent="center">
          <Icon as={BsCameraVideo} color="green.500" />
        </Box>
        <Stack spacing={0}>
          <Text fontWeight={700} color="cuidei.ink" fontSize="sm">
            Médico disponível agora
          </Text>
          <Text fontSize="xs" color="cuidei.muted">
            Espera média: menos de 5 min
          </Text>
        </Stack>
      </Stack>
      <OnlineDot />
    </Stack>
  </Box>
)

export default CuideiAvailabilityPill
